import react, { useEffect, useRef, useState } from "react";
import "../styles/PatientReportFileTemplateCreate.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  updatePrescriptionTemplate,
  postAppointment,
} from "../Redux/Thunk/Actions";
import { prescriptionType, patientid } from "../Redux/Slice/rootSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../assets/images/ascas.svg";
import { PrescriptionFooter } from "./Prescription Footer/PrescriptionFooter";

function RilReportTemplateTwo(props) {
  const secondPageTemplateIds = useSelector(
    (state) => state.counter.secondPageTemplateIdData
  );
  // console.log(secondPageTemplateIds, "lllldhgjas")
  const selectedTab = useSelector((state) => state.counter.prescriptionType);
  const patientId = useSelector((state) => state.counter.patientid);
  const [show, setshow] = useState(false);
  const [NumToWords, setNumToWords] = useState(0);
  // const [NumToWords, setSelected ] = useState("");
  const Content = useRef();
  const [valueChange, setvalueChange] = useState({
    gender1: "Male",
    gender2: "Male",
    bloodGroup1: "A+",
    bloodGroup2: "A+",
  });
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });
  // console.log(valueChange, "lllll")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChange = (e) => {
    setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
    if (e.target.name === "nextappointment") {
      const dateTime = e.target.value.split("T");
      setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
      });
    }
  };

  // useEffect(() => {
  //   console.log(
  //     secondPageTemplateId,
  //     "secondPageTemplateIdsecondPageTemplateId"
  //   );
  // }, []);
  const handletest = (event) => {
    event.preventDefault();
    setshow(true);
    setTimeout(() => {
      const CreateThunk = async () => {
        let htmlPayload;
        htmlPayload = document.getElementById(
          "prescriptionReportWrap"
        ).innerHTML;
        // console.log(htmlPayload, "liki");
        const payload = {
          second_prescription_template: htmlPayload,
        };
        props.loaderchange(true);
        const createNewAppointment = async () => {
          console.log(appointmentData);
          await dispatch(postAppointment(appointmentData));
        };
        createNewAppointment();
        const patentDetails = updatePrescriptionTemplate({
          userData: payload,
          id: secondPageTemplateIds,
        });
        // console.log(
        //   secondPageTemplateIds,
        //   "secondPageTemplateIdsecondPageTemplateIds"
        // );
        const response = await dispatch(patentDetails);
        // const response = "";
        navigate("/PatientView");
        if (response?.payload?.status?.code === 200) {
          props.loaderchange(false);
          navigate("/PatientView");
        } else {
          props.loaderchange("false");
          props.popupalert("true");
          props.popuptext("Network went wrong, Please try after some time.");
          // props.popuptext(response?.status?.message);
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        }
      };
      CreateThunk();
    }, 500);
  };
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black" } } = options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };
  return (
    <>
      <div
        style={{ backgroundColor: "white" }}
        className="patientreport"
        // id="reportcreate"
      >
        {/* Billing Heading */}
        <>
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
        </>
        <div
          style={{
            maxWidth: "97%",
            margin: "0 auto",
            border: "1px solid",
            borderTop: "none",
            paddingTop: "10px",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
          id="reportcreate"
        >
          <table
            style={{
              borderSpacing: "0",
              // marginBottom: "30px",
              width: "98%",
            }}
          >
            <thead
              style={{ border: "1px solid", padding: "0px" }}
              className={`${show ? "hide" : "show"}`}
            >
              <tr
                style={{
                  border: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <th style={{ border: "1px solid", padding: "10px" }}>
                  Factors
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>DATE</th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  Results
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  UTERINE FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* Karyotyping wife and husband*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <span>
                      <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                      &nbsp;Karyotyping wife and husband/
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="geneticDate"
                      style={{
                        padding: "10px",
                        outline: "none",
                        border: "0px",
                      }}
                      type="date"
                    ></input>
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.geneticDate}
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="text"
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="geneticRemarks1"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                        //   width: "100",
                      }}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.geneticRemarks1}
                    </span>
                  </div>
                </td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <span>
                      <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                      &nbsp;y chromosome microdeletion
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="chromosomeDate"
                      style={{
                        padding: "10px",
                        outline: "none",
                        border: "0px",
                      }}
                      type="date"
                    ></input>
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.chromosomeDate}
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="text"
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="chromosomeRemarks"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                        //   width: "100",
                      }}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.chromosomeRemarks}
                    </span>
                  </div>
                </td>
              </tr>
              {/* EMPTY */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* INFECTION*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  INFECTION
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>

              {/* Endometrial biopsy CD-138/TB-PCR/IgM UREAPLASMA/MYCOPLASMA */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Endometrial biopsy CD-138/TB-PCR/IgM
                  UREAPLASMA/MYCOPLASMA
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="biopsyDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.biopsyDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="biopsyRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.biopsyRemark}
                  </span>
                </td>
              </tr>
              {/* EMPTY */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* INFECTION*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  MALE INFECTION
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>

              {/* TSH */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;TSH
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="TSHDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.TSHDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="TSHRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.TSHRemark}
                  </span>
                </td>
              </tr>
              {/* HbA1C/GTT
               */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;HbA1C/GTT
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="GTTDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.GTTDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="GTTRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.GTTRemark}
                  </span>
                </td>
              </tr>

              {/* Sperm DFI */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Sperm DFI
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="DFIDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.DFIDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="DFIRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.DFIRemark}
                  </span>
                </td>
              </tr>
              {/* Smoking/Drug abuse/Alcohol use/ Caffeine */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Smoking/Drug abuse/Alcohol use/ Caffeine
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="DrugDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.DrugDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="DrugRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.DrugRemark}
                  </span>
                </td>
              </tr>
              {/* EMPTY */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* EMBRYO FACTORS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  EMBRYO FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>

              {/* Stimulation protocol-agonist/antagonist/r-LH,GH*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <span>
                      <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                      &nbsp;Stimulation protocol-agonist/antagonist/r-LH,GH
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="antagonistDate"
                      style={{
                        padding: "10px",
                        outline: "none",
                        border: "0px",
                      }}
                      type="date"
                    ></input>
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.antagonistDate}
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="text"
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="antagonistRemark"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                        //   width: "100",
                      }}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.antagonistRemark}
                    </span>
                  </div>
                </td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <span>
                      <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                      &nbsp;Ov-stem cells, Dual stimulation
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="hydrosalpinxDate"
                      style={{
                        padding: "10px",
                        outline: "none",
                        border: "0px",
                      }}
                      type="date"
                    ></input>
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.hydrosalpinxDate}
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="text"
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="hydrosalpinxRemark"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                        //   width: "100",
                      }}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.hydrosalpinxRemark}
                    </span>
                  </div>
                </td>
              </tr>
              {/* Sperm selection-PICSI/MICROFLUIDS/MACS/IMSI */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Sperm selection-PICSI/MICROFLUIDS/MACS/IMSI
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="MACSDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.MACSDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="MACSRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.MACSRemark}
                  </span>
                </td>
              </tr>
              {/* Oocyte Donor/Embryo Donation*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Oocyte Donor/Embryo Donation
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="OocyteDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.OocyteDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="OocyteRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.OocyteRemark}
                  </span>
                </td>
              </tr>
              {/* PGT A*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;PGT A
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="PGTDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.PGTDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="PGTRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.PGTRemark}
                  </span>
                </td>
              </tr>
              {/*Empty*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* EMBRYO FACTORS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  EMBRYO TRANSFER
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* GA/Conscious*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;GA/Conscious
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="GAConsciousDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.GAConsciousDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="GAConsciousRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.GAConsciousRemark}
                  </span>
                </td>
              </tr>
              {/* Trial Transfer-Easy/Difficult-Cervical Shaving/Hysteroscopy*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Trial Transfer-Easy/Difficult-Cervical
                  Shaving/Hysteroscopy
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="TransferDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.TransferDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="TransferRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.TransferRemark}
                  </span>
                </td>
              </tr>
              {/*Empty*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* EMBRYO FACTORS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  POST ET ADJUVANTS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* Progesterone Gel/Injection/LMWH/INTRALIPIO /BHARGLOBIN/Glucocorticoids IVIG*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Progesterone Gel/Injection/LMWH/INTRALIPIO
                  /BHARGLOBIN/Glucocorticoids IVIG
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="IVIGDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.IVIGDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="IVIGRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.IVIGRemark}
                  </span>
                </td>
              </tr>
              {/*Empty*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <p style={{ fontWeight: "600" }}>
        NEXT APPOINTMENT -{" "}
        <input
          name="nextappointment"
          onChange={handleChange}
          type="datetime-local"
          // type="date"
        />
      </p>
      {/* Footer */}
      <div className="Footer">
        <button
          onClick={(event) => {
            handletest(event);
          }}
          className="Button_Create"
        >
          Generate
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <div>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  {renderTableTH("Factors")}
                  {renderTableTH("Date")}
                  {renderTableTH("Results")}
                </tr>
              </thead>
              <tbody>
                <tr>{renderTableTH("UTERINE FACTORS", { colspans: 3 })}</tr>
                {[
                  " • Karyotyping wife and husband",
                  " • y chromosome microdeletion",
                ].map((ele, ind) => {
                  let value = [
                    "geneticDate||geneticRemarks1",
                    "chromosomeDate||chromosomeRemarks",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("INFECTION FACTORS", { colspans: 3 })}</tr>
                {[
                  " • Endometrial biopsy CD-138/TB-PCR/IgM UREAPLASMA/MYCOPLASMA",
                ].map((ele, ind) => {
                  let value = ["biopsyDate||biopsyRemark"];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>
                  {renderTableTH("MALE INFECTION FACTORS", { colspans: 3 })}
                </tr>
                {[
                  " • TSH",
                  " • HbA1C/GTT",
                  " • Sperm DFI",
                  " • Smoking/Drug abuse/Alcohol use/ Caffeine",
                ].map((ele, ind) => {
                  let value = [
                    "TSHDate||TSHRemark",
                    "GTTDate||GTTRemark",
                    "DFIDate||DFIRemark",
                    "DrugDate||DrugRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("EMBRYO FACTORS", { colspans: 3 })}</tr>
                {[
                  " • Stimulation protocol-agonist/antagonist/r-LH,GH",
                  " • Ov-stem cells, Dual stimulation",
                  " • Sperm selection-PICSI/MICROFLUIDS/MACS/IMSI",
                  " • Oocyte Donor/Embryo Donation",
                  " • PGT A",
                ].map((ele, ind) => {
                  let value = [
                    "antagonistDate||antagonistRemark",
                    "hydrosalpinxDate||hydrosalpinxRemark",
                    "MACSDate||MACSRemark",
                    "OocyteDate||OocyteRemark",
                    "PGTDate||PGTRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("EMBRYO TRANSFER", { colspans: 3 })}</tr>
                {[
                  " • GA/Conscious",
                  " • Trial Transfer-Easy/Difficult-Cervical Shaving/Hysteroscopy",
                ].map((ele, ind) => {
                  let value = [
                    "GAConsciousDate||GAConsciousRemark",
                    "TransferDate||TransferRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("POST ET ADJUVANTS", { colspans: 3 })}</tr>
                {[
                  " • Progesterone Gel/Injection/LMWH/INTRALIPIO /BHARGLOBIN/Glucocorticoids IVIG",
                ].map((ele, ind) => {
                  let value = ["IVIGDate||IVIGRemark"];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
            {renderReportfield(
              "Next Appointment : ",
              appointmentData.date?.split("-").reverse().join("-")
            )}
          </div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </>
  );
}

export default RilReportTemplateTwo;
